import React from 'react';
import './style.scss';
import infoImage from '../../../../assets/images/login-info-img.png';

const Info = () => {
	return (
		<section className="login-page__info info">
			<div className="info__image">
				<img src={infoImage} alt="" />
			</div>
			<div className="info__content">
				<h3 className="info__heading">Wystarczy kilka minut,</h3>
				<p className="info__text">
					by wygenerować zestaw zadań dla uczniów. Generator testów to baza gotowych zadań dla
					uczniów szkół podstawowych, ponadgimnazjalnych, ponadpodstawowych i szkół branżowych.
					Stwórz własną bazę testów dla uczniów.
				</p>
			</div>
		</section>
	);
};

export default Info;
